import BreadCrumbMUI, { BreadcrumbsProps } from '@material-ui/core/Breadcrumbs';

export const BreadCrumbs: React.FC<BreadcrumbsProps> = ({ children, ...rest }) => {
	return <BreadCrumbMUI {...rest}>{children}</BreadCrumbMUI>;
};
